// oxlint-disable typescript/no-duplicate-enum-values -- intentional aliases: multiple enum members share the same i18n key for legacy/backwards-compatibility reasons
import { i18n as i18nFn, I18n as I18nReact } from "@lookiero/i18n-react";
import { EndpointFunction, fetchTranslations, translationEndpoints } from "@lookiero/sty-psp-i18n";
import { Tradename } from "@lookiero/sty-sp-tradename";

const DOMAIN = "LookInI18n";

const CATEGORY_NAME_PREFIX = "shop.categories";
const SALES_NAME_PREFIX = "shop.sales";

enum I18nMessages {
  ORDER_RETURN_CTA = "shop.myOrders.return.buttom_return",
  ORDER_RETURN_TITLE = "shop.myOrders.return.header",
  ORDER_RETURN_INTRO = "shop.myOrders.return.select_items",

  ORDER_FREE = "shop.myOrders.order.free",
  ORDER_TOTAL = "shop.myOrders.order.total",
  ORDER_TOTAL_ITEM = "shop.myOrders.order.total_item",
  ORDER_TOTAL_ITEMS = "shop.myOrders.order.total_items",
  ORDER_TOTAL_ITEMS_UNAVAILABLE = "shop.myOrders.order.total_items_cancelled",
  ORDER_TOTAL_ITEMS_RETURNED = "shop.myOrders.order.total_items_returned",
  ORDER_TOTAL_ITEMS_PENDING_RETURN = "shop.myOrders.order.total_items_pending_return",
  ORDER_SHIPPING = "shop.myOrders.order.shipping",
  ORDER_HEADER = "shop.myOrders.order.header",
  ORDER_RETURN_ITEMS_CTA = "shop.myOrders.order.buttom_return_items",
  ORDER_RETURN_MESSAGE_FIRST = "shop.myOrders.order.return_confirmation_box_1",
  ORDER_RETURN_MESSAGE_SECOND = "shop.myOrders.order.return_confirmation_box_2",
  ORDER_HELP_RETURN_TEXT = "shop.myOrders.order.return_more_articles",
  ORDER_HELP_RETURN_LINK = "shop.myOrders.order.Contact.our.Customer.Service",
  ORDER_CONFIRMATED_DATE = "shop.myOrders.order.confirmed_date",
  ORDER_ADDRESS = "shop.myOrders.order.address",
  ORDER_HELP_TEXT = "shop.myOrders.order.doubts",
  ORDER_HELP_LINK = "shop.myOrders.order.helpcenter",
  ORDER_SHOW_RETURN_INSTRUCTIONS = "shop.myOrders.order.return_see_instructions",
  ORDER_CLOSED = "shop.myOrders.order.closed",

  TOTAL_LINE_DISCARDED = "shop.myOrders.order.total_items_cancelled",

  ORDERS_HEADER = "shop.myOrders.list.header",
  ORDERS_ARTICLE = "shop.myOrders.list.article",
  ORDERS_ARTICLES = "shop.myOrders.list.articles",
  ORDERS_REFERENCE = "shop.myOrders.list.reference",
  ORDERS_STATUS_SELECTION_DONE = "shop.myOrders.list.status.inWarehouse",
  ORDERS_STATUS_WAREHOUSE_ERROR = "shop.myOrders.list.status.inWarehouse",
  ORDERS_STATUS_SENT = "shop.myOrders.list.status.sent",
  ORDERS_STATUS_DELIVERY_NOTIFIED = "shop.myOrders.list.status.delivered",
  ORDERS_STATUS_DISCARDED = "shop.myOrders.list.status.cancelled",
  ORDERS_STATUS_CLOSED = "shop.myOrders.list.status.closed",
  ORDERS_STATUS_CANCELLED = "shop.myOrders.list.status.cancelled",

  RETURNED_ORDER_HEADER = "shop.myOrders.return_confirmation.header",
  RETURNED_ORDER_BODY_FIRST = "shop.myOrders.return_confirmation.body_1",
  RETURNED_ORDER_BODY_SECOND = "shop.myOrders.return_confirmation.body_2",
  RETURNED_ORDER_INSTRUCTIONS_CTA = "shop.myOrders.return_confirmation.buttom_instructions",
  RETURNED_ORDER_MORE_LOOKS_CTA = "shop.myOrders.return_confirmation.buttom_more_looks",

  RETURN_INFORMATION_ABOUT_BALANCE = "shop.myOrders.return_information_about_balance",

  NO_LOOK_INVITE_BOX_TITLE = "shop.browsing.noLookAvailable.inviteBoxTitle",
  NO_LOOK_INVITE_BOX_BODY = "shop.browsing.noLookAvailable.inviteBoxBody",
  NO_LOOK_INVITE_BOX_CTA = "shop.browsing.noLookAvailable.inviteBoxCTA",
  NO_LOOK_INVITE_BODY = "shop.browsing.noLookAvailable.inviteBody",
  NO_LOOK_INVITE_TITLE = "shop.browsing.noLookAvailable.inviteTitle",
  NO_LOOK_INVITE_SEPARATOR = "shop.browsing.noLookAvailable.separator",

  LABEL_OUT_OF_STOCK = "shop.label.out_of_stock",
  LABEL_LAST_ITEMS = "shop.label.last_units",
  LABEL_LAST_ITEMS_QUANTITY = "shop.basket_checkout.lastUnitsQuantity",

  EMPTY_OPTION = "dropdown.emptyOption.text",

  RETURN_FEEDBACK_OPINION = "shop.myShopOrders.select.return.opinion",
  RETURN_FEEDBACK_WHY = "shop.myShopOrders.returnFeedback.why",
  RETURN_FEEDBACK_COMMENT = "shop.myShopOrders.returnFeedback.comment",
  RETURN_FEEDBACK_COMMENT_PLACEHOLDER = "shop.myShopOrders.returnFeedback.comment_placeholder",
  RETURN_FEEDBACK_MORE_PRODUCTS = "shop.myShopOrders.returnFeedback.return_more",
  RETURN_FEEDBACK_CONTINUE = "shop.myShopOrders.returnFeedback.continue",

  CONFIRM_RETURN_FEEDBACK_ERROR = "shop.myShopOrders.confirmReturn.error.default",
  CONFIRM_RETURN_FEEDBACK_EMPTY_ERROR = "shop.myShopOrders.confirmReturn.error.empty",

  MY_ORDER_EMPTY_TITLE = "shop.myShopOrders.empty.title",
  MY_ORDER_EMPTY_BODY = "shop.myShopOrders.empty.body",

  SALES_NOTIFICATION_TITLE = "shop.sales.notification_text1",
  SALES_NOTIFICATION_CONTENT = "shop.sales.notification_text2",
  SALES_NOTIFICATION_LINK = "shop.sales.notification_link",
  SALES_TITLE = "shop.sales.mainTitle",
  SALES_SUBTITLE = "shop.sales.mainSubtitle",

  SALES_CATEGORIES_BANNER_TOP_TITLE = "shop.banner.sales_title",
  SALES_CATEGORIES_BANNER_TITLE = "shop.banner.sales_body",
  SALES_CATEGORIES_BANNER_DESCRIPTION = "shop.banner.sales_content",
  SALES_CATEGORIES_BANNER_CTA = "shop.categories.sales_banner_grid_ctra",

  CATEGORIES_BANNER_TOP_TITLE = "shop.sales.banner_grid_top_tittle",
  CATEGORIES_BANNER_TITLE = "shop.sales.banner_grid_title",
  CATEGORIES_BANNER_DESCRIPTION = "shop.sales.banner_grid_subtitle",
  CATEGORIES_BANNER_CTA = "shop.sales.banner_grid_cta",

  FOOTER_LEGAL_TEXT = "shop.sales.legaltext",
  FOOTER_TITLE = "shop.categories.finalComponent.title",
  FOOTER_DESCRIPTION = "shop.categories.finalComponent.description",

  FOOTER_CROSSELLING_BANNER_TITLE = "shop.browsing.noLookAvailable.inviteBoxTitle",
  FOOTER_CROSSELLING_BANNER_DESCRIPTION = "shop.browsing.noLookAvailable.inviteBoxBody",
  FOOTER_CROSSELLING_BANNER_CTA = "Shop.CYL.Empty_State_Unlock_CTA",

  PILL_COMPLETE_YOUR_LOOK = "shop.categories.offeringPills.completeYourLook",
  PILL_TRENDING_FOR_YOU = "shop.categories.offeringPills.T4U",
  PILL_CATEGORIES = "shop.categories.offeringPills.Categories",
  PILL_SALES = "shop.categories.offeringPills.sales",
  CATEGORIES_TITLE = "shop.categories.title",
  CATEGORIES_SUBTITLE = "shop.categories.subtitle",

  HEADER_TITLE = "shop.header.title",

  EMPTY_STATE_CTA = "shop.basket.empty.CTA",

  BASKET_HEADER_TITLE = "shop.basket.header.title",
  BASKET_EMPTY_STATE_TITLE = "shop.basket.empty.title",
  BASKET_EMPTY_STATE_TEXT = "shop.basket.empty.body",
  BASKET_CTA = "shop.basket.buyCTA.content",
  BASKET_LIMITED_STOCK_INFO = "shop.basket.message.limited_stock_info",
  BASKET_TOTAL_PRICE = "shop.basket.priceSummary.total",

  BASKET_INFO_FREE_SHIPPING_AND_RETURN = "shop.basket.info1",
  BASKET_INFO_FAST_DELIVERY = "shop.basket.info2",
  RESUME_RETURN_TIME = "shop.basket_checkout.info_CTA",

  BASKET_BENEFITS_CYL_TITLE = "shop.basket.benefits_cyl_title",
  BASKET_BENEFITS_CYL_SUBTITLE = "shop.basket.benefits_cyl_subtitle",

  ITEM_NOT_AVAILABLE = "Shop.item_not_available",
  ITEM_NOT_AVAILABLE_SUBTITLE = "shop.item_not_available_subtitle",

  CROSS_SELLING_TOP_SELLING_TITLE = "shop.cross.module_best_sellers",
  CROSS_SELLING_LOOK_LIKE_TITLE = "shop.cross.module_lookandlike",
  CROSS_SELLING_SIMILAR_TITLE = "shop.cross.module_similarproducts",

  THANK_YOU_HEADER = "shop.thank_you_page.header",
  THANK_YOU_BODY = "shop.thank_you_page.body",
  THANK_YOU_TITLE = "shop.thank_you_page.title",

  CHECKOUT_DELIVERY_TIME = "shop.xo.delivery_time.content",
  CHECKOUT_TITLE = "shop.xo.title",
  CHECKOUT_FREE = "shop.xo.free",
  CHECKOUT_HEADER = "shop.xo.header.title",
  CHECKOUT_HOME_DELIVERY = "shop.xo.home_delivery",
  CHECKOUT_DELIVERY_FREE_COST = "shop.xo.price_summary.free_delivery_cost",
  CHECKOUT_ITEM = "shop.xo.price_summary.quantity.singular",
  CHECKOUT_ITEMS = "shop.xo.price_summary.quantity.plural",
  CHECKOUT_TOTAL = "shop.xo.price_summary.total",
  CHECKOUT_RETURNS_TITLE = "shop.xo.returns_info.title",
  CHECKOUT_RETURNS_TEXT1 = "shop.xo.returns_info.text1",
  CHECKOUT_RETURNS_TEXT2 = "shop.xo.returns_info.text2",
  CHECKOUT_RETURNS_TEXT3 = "shop.xo.returns_info.text3",
  CHECKOUT_BUY_NOW_TITLE = "shop.basketXo.buyNow.title",
  CHECKOUT_BUY_NOW_SUBTITLE = "shop.basketXo.buyNow.text",
  CHECKOUT_INFO_PROMO = "shop.checkoutPage.info_promos_not_applied_in_sales",
  CHECKOUT_SUMMARY_SALES_LINEDESC = "shop.checkoutPage.summary_sales_lineDesc",
  CHECKOUT_SUMMARY_BALANCE_LINE = "shop.checkoutPage.summary_balance_line",

  CHECKOUT_CONFIRMATION_GO_TO_ORDER = "shop.confirmationPage.goToMyOrder",
  CHECKOUT_CONFIRMATION_EXTRA_INFO = "shop.confirmationPage.extraInformation",

  EDIT_ADDRESS_TITLE = "shop.modal.edit.address.title",
  EDIT_ADDRESS_TEXT_FIRST = "shop.modal.edit.address.text1",
  EDIT_ADDRESS_TEXT_SECOND = "shop.modal.edit.address.text2",
  EDIT_ADDRESS_TEXT_CTA = "shop.modal.edit.address.button",

  STOCK_OUT_MODAL_TITLE = "Shop.checkout.stock.modal.title",
  STOCK_OUT_MODAL_NO_ITEMS_TITLE = "Shop.checkout.stock.modal.noitems.title",
  STOCK_OUT_MODAL_BODY = "Shop.checkout.stock.modal.text",
  STOCK_OUT_MODAL_NO_ITEMS_BODY = "Shop.checkout.stock.modal.noitems.text",
  STOCK_OUT_MODAL_BUTTON_BACK = "Shop.checkout.stock.modal.button1",
  STOCK_OUT_MODAL_BUTTON_DELETE_AND_PAY = "Shop.checkout.stock.modal.button2",
  STOCK_OUT_MODAL_BUTTON_CLOSE_AND_GO = "Shop.checkout.stock.modal.noitems.button2",
  STOCK_OUT_NOTIFICATION_REMOVED = "shop.checkout.toast_stockout_removed",

  BANNER_LOOK_AND_LIKE_TOP_TITLE = "Shop.banner.typ.lookandlike.title",
  BANNER_LOOK_AND_LIKE_TITLE = "Shop.banner.typ.lookandlike.text1",
  BANNER_LOOK_AND_LIKE_DESCRIPTION = "Shop.banner.typ.lookandlike.text2",
  BANNER_LOOK_AND_LIKE_CTA = "Shop.banner.typ.lookandlike.button",

  CYL_BOTTOM_TITLE = "shop.complete_your_look.bottom.title",
  CYL_BOTTOM_SUBTITLE = "shop.complete_your_look.bottom.subtitle",
  CYL_TITLE = "shop.complete_your_look.Title",
  CYL_SUBTITLE = "shop.complete_your_look.subtitle",
  CYL_NOTIFICATION_TEXT = "shop.complete_your_look.notification_text",
  CYL_NOTIFICATION_LINK = "shop.complete_your_look.notification_link",

  CYL_CROSS_NAVIGATION_TITLE = "shop.complete_your_look.cross_navigation_title",
  CYL_CROSS_NAVIGATION_DESCRIPTION = "shop.onboarding.categories_subtitle",
  CYL_CROSS_NAVIGATION_SUBTITLE_FIRST = "shop.complete_your_look.cross_navigation_subtitle",
  CYL_CROSS_NAVIGATION_SUBTITLE_SECOND = "shop.complete_your_look.cross_navigation_subtitle2",
  CYL_CROSS_NAVIGATION_CTA = "shop.complete_your_look.cross_navigation_cta",
  CYL_YOUR_GARMENT = "shop.complete_your_look.your_garment",
  CYL_EMPTY_STATE_TITLE = "shop.complete_your_look.empty_state_title",
  CYL_EMPTY_STATE_SUBTITLE_FIRST = "shop.complete_your_look.empty_state_subtitle1",
  CYL_EMPTY_STATE_SUBTITLE_SECOND = "shop.complete_your_look.empty_state_subtitle2",
  CYL_EMPTY_STATE_CTA = "shop.complete_your_look.empty_state_cta",

  CYL_EMPTY_STATE_UNLOCK_TITLE = "Shop.CYL.Empty_State_Unlock_Title1",
  CYL_EMPTY_STATE_UNLOCK_SUBTITLE = "Shop.CYL.Empty_State_Unlock_Subtitle",
  CYL_EMPTY_STATE_UNLOCK_BENEFIT1 = "Shop.CYL.Empty_State_Unlock_Benefit1",
  CYL_EMPTY_STATE_UNLOCK_BENEFIT2 = "Shop.CYL.Empty_State_Unlock_Benefit2",
  CYL_EMPTY_STATE_UNLOCK_BENEFIT3 = "Shop.CYL.Empty_State_Unlock_Benefit3",
  CYL_EMPTY_STATE_UNLOCK_CTA = "Shop.CYL.Empty_State_Unlock_CTA",

  WISHLIST_TITLE = "shop.wishlist.header.with.items",
  WISHLIST_ADD_ITEM = "shop.wishlist.add.item",
  WISHLIST_NOTIFICATION_ITEM_ADDED = "shop.wishlist.item_favorited_toast",
  WISHLIST_NOTIFICATION_ITEM_REMOVED = "shop.wishlist.item_favorited_remove_toast",
  WISHLIST_ITEM_ADDED = "shop.wishlist_item_added",
  WISHLIST_INFORMATION_TEXT = "shop.wishlist.information.text",
  WISHLIST_EMPTY_STATE_TITLE = "shop.wishlist.header.empty.state.title",
  WISHLIST_EMPTY_STATE_TEXT = "shop.wishlist.header.empty.state.text",

  COMPLETE_YOUR_LOOK_TITLE = "shop.detailPage.carouselLook.title",

  PRODUCT_AVAILABILITY_MODAL_BODY = "shop.detail_page.availability_modal.body",
  PRODUCT_AVAILABILITY_MODAL_TITLE = "shop.detail_page.availability_modal.title",
  PRODUCT_ADD_TO_CART_CTA = "shop.detailPage.AddToCartCTA",
  PRODUCT_DELIVERY_BODY = "shop.detailPage.DeliveryAccordion.body",
  PRODUCT_DELIVERY_TITLE = "shop.detailPage.DeliveryAccordion.title",
  PRODUCT_DELIVERY = "shop.productPage.delivery",
  PRODUCT_DELIVERY_VALUE = "shop.productPage.deliveryValue",
  PRODUCT_RETURN = "shop.productPage.return",
  PRODUCT_RETURN_VALUE = "shop.productPage.returnValue",
  PRODUCT_EASY_RETURN = "shop.productPage.easyReturn",
  PRODUCT_EASY_RETURN_VALUE = "shop.productPage.easyReturnValue",
  PRODUCT_RETURN_GUIDE = "shop.productPage.returnGuide",
  PRODUCT_RETURN_GUIDE_VALUE = "shop.productPage.returnGuideValue",
  PRODUCT_REFUND = "shop.productPage.refund",
  PRODUCT_REFUND_VALUE = "shop.productPage.refundValue",
  PRODUCT_DESCRIPTION_TITLE = "shop.detailPage.DescriptionAccordion.title",
  PRODUCT_COLOR = "shop.garmentdetail.color",
  PRODUCT_INFO_SIZE = "shop.garmentdetail.size",
  PRODUCT_STOCK_OUT_MODAL_TITLE = "Shop.productpage.stockout.modal.title",
  PRODUCT_STOCK_OUT_MODAL_BODY = "Shop.productpage.stockout.modal.body",
  PRODUCT_STOCK_OUT_MODAL_CTA = "Shop.productpage.stockout.modal.button",
  PRODUCT_STOCK_OUT_CTA = "Shop.productpage.stockout.button",
  PRODUCT_STOCK_OUT_NOTIFICATION_ERROR = "Shop.productpage.stockout.toast.error",
  PRODUCT_STOCK_OUT_NOTIFICATION_SUCCESS = "Shop.productpage.stockout.text",
  PRODUCT_NOT_AVAILABLE_ITEM = "shop.product.page.item_not_available",
  PRODUCT_REFERENCE = "Shop.product.page_ref",
  PRODUCT_FREE_RETURNS = "shop.productPage.info_CTA",
  PRODUCT_MODAL_ZOOM_NUMBER = "shop.product_page.modalZoomNumber",
  PRODUCT_COMPOSITION_CARE_TITLE = "shop.productPage.composition_care",
  PRODUCT_SIZE_ADJUST_TITLE = "shop.productPage.size_adjust",
  PRODUCT_SIZE_MODEL = "shop.product_page.size_model",
  PRODUCT_WATCH_PP = "shop.productPage.watch_product_details",
  PRODUCT_LABEL_LAST_ITEMS_QUANTITY = "shop.productPage.lastUnitsQuantity",

  PRODUCT_SIZE_SELECTOR_ITEM_ADDED = "shop.sizeselection.confirmationMessage.text",
  PRODUCT_RECOMMENDED_SIZE = "shop.sizeselection.yoursize.title",
  PRODUCT_SIZE_SELECTOR = "shop.sizeselection.main.title",

  BENEFITS_CYL_TITLE = "shop.product_page.benefits_cyl_title",
  BENEFITS_CYL_SUBTITLE = "shop.product_page.benefits_cyl_subtitle",
  BENEFITS_CATS_TITLE = "shop.product_page.benefits_cats_title",
  BENEFITS_CATS_SUBTITLE = "shop.product_page.benefits_cats_subtitle",
  BENEFITS_MORE_LOOKS_BUTTON = "shop.product_page.benefits_morelooks_button",

  UPDATE_YOUR_PROFILE_TITLE = "Shop.CYL.Empty_State_NoLooks_Title1",
  UPDATE_YOUR_PROFILE_SUBTITLE = "Shop.CYL.Empty_State_NoLooks_Subtitle",
  UPDATE_YOUR_PROFILE_CTA = "Shop.CYL.Empty_State_NoLooks_CTA",

  TRENDING_FOR_YOU_BOTTOM_TITLE = "shop.trending_for_you.bottom.title",
  TRENDING_FOR_YOU_BOTTOM_SUBTITLE = "shop.trending_for_you.bottom.subtitle",
  TRENDING_FOR_YOU_TITLE = "shop.trending_for_you.title",
  TRENDING_FOR_YOU_SUBTITLE = "shop.trending_for_you.subtitle",
  TRENDING_FOR_YOU_CROSS_NAVIGATION_TITLE = "shop.trending_for_you.cross_navigation_title",
  TRENDING_FOR_YOU_CROSS_NAVIGATION_TEXT = "shop.trending_for_you.cross_navigation_text",
  TRENDING_FOR_YOU_CROSS_NAVIGATION_SUBTITLE_FIRST = "shop.trending_for_you.cross_navigation_subtitle",
  TRENDING_FOR_YOU_CROSS_NAVIGATION_SUBTITLE_SECOND = "shop.trending_for_you.cross_navigation_subtitle2",
  TRENDING_FOR_YOU_CROSS_NAVIGATION_CTA = "shop.trending_for_you.cross_navigation_cta",
  TRENDING_FOR_YOU_FOOTER_TITLE = "shop.trending_for_you.bottom.title",
  TRENDING_FOR_YOU_FOOTER_SUBTITLE = "shop.trending_for_you.bottom.subtitle",
}

const cache = new Map<Tradename, I18nReact>();

interface I18nFunctionArgs {
  readonly tradename: Tradename;
}

interface I18nFunction {
  (args: I18nFunctionArgs): I18nReact;
}

const i18n: I18nFunction = ({ tradename }) => {
  if (cache.has(tradename)) {
    return cache.get(tradename)!;
  }

  const translations: EndpointFunction[] = [
    (locale) =>
      translationEndpoints({
        projects: ["look-in", "user-area-front", "inventory-catalog"],
        tradename,
      })(locale),
  ];

  const component = i18nFn({
    fetchTranslation: fetchTranslations({ translations }),
    domain: DOMAIN,
  });

  cache.set(tradename, component);
  return component;
};

export { DOMAIN, I18nMessages, CATEGORY_NAME_PREFIX, SALES_NAME_PREFIX, i18n };
